import * as React from 'react';

export type BaseInputProps = Omit<React.ComponentProps<'input'>, 'onChange' | 'type'>;

export const inputClassNames =
  'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground enabled:focus-visible:outline-none enabled:focus-visible:ring-1 enabled:focus-visible:ring-ring read-only:ring-0! disabled:cursor-not-allowed disabled:opacity-50 md:text-sm';
